<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useI18n } from 'vue-i18n';
import { CONTENT_TYPES } from '../constants.js';
import { useMessageContext } from '../provider.js';
import { useInbox } from 'dashboard/composables/useInbox';

const { content, contentAttributes, contentType } = useMessageContext();
const { t } = useI18n();
const { isAWebWidgetInbox } = useInbox();

const formValues = computed(() => {
  if (contentType.value === CONTENT_TYPES.FORM) {
    const { items, submittedValues = [] } = contentAttributes.value;

    if (submittedValues.length) {
      return submittedValues.map(submittedValue => {
        const item = items.find(
          formItem => formItem.name === submittedValue.name
        );
        return {
          title: submittedValue.value,
          value: submittedValue.value,
          label: item?.label,
        };
      });
    }

    return [];
  }

  if (contentType.value === CONTENT_TYPES.INPUT_SELECT) {
    const [item] = contentAttributes.value?.submittedValues ?? [];
    if (item) {
      return [
        {
          title: item.title,
          value: item.value,
          label: '',
        },
      ];
    }

    return [];
  }

  return [];
});

const offeredOptions = computed(() => {
  if (contentType.value !== CONTENT_TYPES.INPUT_SELECT) return [];
  if (formValues.value.length) return [];

  return contentAttributes.value?.items ?? [];
});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="csat">
    <span v-dompurify-html="content" :title="content" />
    <dl v-if="formValues.length" class="mt-4">
      <template v-for="item in formValues" :key="item.title">
        <dt class="text-n-slate-11 italic mt-2">
          {{ item.label || t('CONVERSATION.RESPONSE') }}
        </dt>
        <dd>{{ item.title }}</dd>
      </template>
    </dl>
    <div v-else-if="offeredOptions.length" class="mt-3">
      <p class="text-n-slate-11 italic text-xs mb-1.5">
        {{ t('CONVERSATION.OPTIONS_OFFERED') }}
      </p>
      <div class="flex flex-wrap gap-1.5">
        <span
          v-for="(option, index) in offeredOptions"
          :key="index"
          class="inline-flex items-center px-2.5 py-1 rounded-full text-xs bg-n-alpha-1 text-n-slate-11 border border-n-weak"
        >
          {{ option.title }}
        </span>
      </div>
    </div>
    <div v-else-if="isAWebWidgetInbox" class="my-2 font-medium">
      {{ t('CONVERSATION.NO_RESPONSE') }}
    </div>
  </BaseBubble>
</template>
